import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { LegacySearchIndexCourse, VatSettings } from '@shared/types';
import { PublicCourse } from '@cademy-package/sdk-component-types';

type VATLabelProps = {
    course: PublicCourse | LegacySearchIndexCourse;
    priceLabel: string;
    vatSettings?: VatSettings;
};

export const VATLabel: FunctionComponent<VATLabelProps> = ({ course, priceLabel, vatSettings }) => {
    if (course.type === 'on-request' && course.pricing_option) {
        if (['free', 'price-on-enquiry'].includes(course.pricing_option.type)) {
            return null;
        }
    }

    if (!vatSettings || !vatSettings.enabled) {
        return null;
    }

    if (priceLabel.toLowerCase() === 'free') {
        return null;
    }

    if (vatSettings.enabled) {
        if (vatSettings.is_vat_absorbed) {
            return (
                <span className={styles.vatLabel}>(incl. {vatSettings.tax_label || 'Tax'})</span>
            );
        }
        return <span className={styles.vatLabel}>+ {vatSettings.tax_label || 'Tax'}</span>;
    }

    return null;
};
